import { store } from '../../store';

export default async (to: any, from: any, next: Function) => {

    if (to.matched.some((record: any) => !!record.meta.guest)) {
        return handleAuthGuestRoute(next);
    }

    if (to.matched.some((record: any) => record.meta.requiresAuth)) {

        let requiredVerification = to.matched.some((record: any) => record.meta.requiresVerification)
        let requiresNoPendingVerification = to.matched.some((record: any) => record.meta.requiresNoPendingVerification)

        return handleAuthProtectedRoute(next, requiredVerification, requiresNoPendingVerification);

    }

    next();

};

async function handleAuthGuestRoute(next: Function) {
    if (await isLoggedIn()) {
        next({ name: 'account' });
        return;
    }
    next();
}

async function handleAuthProtectedRoute(next: Function, requiredVerification: boolean = false, requiresNoPendingVerification: boolean = false) {

    if (!await isLoggedIn()) {

        next({ name: 'login' });
        return

    }

    if (requiredVerification) {

        if ( await isVerified()) {
            next();
        }
        else {
            if (store.getters.getVerificationInProgress) {
                next({ name: 'account-verify-pending' });
            }
            else {
                next({ name: 'account-verify' });
            }
        }

    }
    else if (requiresNoPendingVerification) {

        if ( await isVerified()) {
            next({ name: 'account' });
        }
        else if (store.getters.getVerificationInProgress) {
            next({ name: 'account-verify-pending' });
        }
        else {
            next()
        }

    }
    else {
        next();
    }

}

let waitAsync = async function (millis: number) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve()
        }, millis)
    })
}

async function isLoggedIn() {

    let checkingSession = store.getters.getCheckingSession

    if (checkingSession) {

        while (checkingSession) {

            await waitAsync(100)

            checkingSession = store.getters.getCheckingSession

        }

    }

    return store.getters.getLoggedInState

}

async function isVerified() {
    return store.getters.getLoggedInUser.verified
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/guards/auth.ts